import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-carbon border-t border-smoke pt-20 pb-10 mt-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div>
          <img
            src="https://customer-assets.emergentagent.com/job_prestige-omni-store/artifacts/8poujyff_mhlumora%20logo.jpg"
            alt="M&H Lumora"
            className="h-16 w-auto object-contain mb-4 -ml-2"
            style={{ mixBlendMode: "screen" }}
          />
          <p className="text-ivory/60 text-sm leading-relaxed font-light max-w-xs">
            Joyería, floristería y cosmética premium. Una experiencia editorial donde cada pieza cuenta una historia.
          </p>
          <div className="flex gap-4 mt-6">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-ivory/60 hover:text-gold transition-colors" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-ivory/60 hover:text-gold transition-colors" aria-label="Facebook"><Facebook size={18} /></a>
            <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-ivory/60 hover:text-gold transition-colors" aria-label="Twitter"><Twitter size={18} /></a>
          </div>
        </div>

        <div>
          <p className="overline mb-4">Boutique</p>
          <ul className="space-y-3 text-sm text-ivory/80 font-light">
            <li><Link to="/shop/maquillaje" className="hover:text-gold transition-colors">Maquillaje</Link></li>
            <li><Link to="/shop/perfumeria" className="hover:text-gold transition-colors">Perfumería</Link></li>
            <li><Link to="/shop/cosmetica" className="hover:text-gold transition-colors">Cosmética</Link></li>
            <li><Link to="/shop" className="hover:text-gold transition-colors">Todas las categorías</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Atelier</p>
          <ul className="space-y-3 text-sm text-ivory/80 font-light">
            <li><Link to="/blog" className="hover:text-gold transition-colors">Editorial</Link></li>
            <li><Link to="/p/about" className="hover:text-gold transition-colors">Nuestra historia</Link></li>
            <li><Link to="/p/shipping" className="hover:text-gold transition-colors">Envíos</Link></li>
            <li><Link to="/p/returns" className="hover:text-gold transition-colors">Devoluciones</Link></li>
          </ul>
        </div>

        <div>
          <p className="overline mb-4">Newsletter</p>
          <p className="text-sm text-ivory/60 mb-4 font-light leading-relaxed">
            Reciba el primer acceso a colecciones, eventos privados y lookbooks.
          </p>
          <form className="flex border-b border-smoke" onSubmit={e => e.preventDefault()}>
            <input
              data-testid="newsletter-input"
              type="email"
              placeholder="su@email.com"
              className="flex-1 bg-transparent py-3 text-sm text-ivory placeholder:text-ivory/40 outline-none"
            />
            <button data-testid="newsletter-submit" type="submit" className="text-gold text-xs uppercase tracking-widest px-3">→</button>
          </form>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-16 pt-6 border-t border-smoke flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-xs text-ivory/40 tracking-wider">© MMXXVI · M&H Lumora · Tous droits réservés</p>
        <div className="flex gap-6 text-xs text-ivory/40 tracking-wider">
          <Link to="/p/privacy" className="hover:text-gold">Privacidad</Link>
          <Link to="/p/terms" className="hover:text-gold">Términos</Link>
          <Link to="/p/shipping" className="hover:text-gold">Envíos</Link>
        </div>
      </div>
    </footer>
  );
}
